<template>
  <component
    :is="tag || 'span'"
    :key="translation"
    v-thtml="translation"
    v-bind="$attrs"
  />
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class Translate extends Vue {
  @Prop()
  tt: Record<string, unknown>

  @Prop()
  tag: string

  translationKey: string | null = null

  beforeUpdate() {
    this.translationKey = this.getTranslationKey()
  }

  // note this is not a computed getter since $slots aren't reactive
  getTranslationKey() {
    // @TODO fix - quick fix copied from here: https://stackoverflow.com/questions/42950967/how-to-reference-text-thats-in-slot-slot-in-vue-js
    const getTextFromNode = (node) => {
      if (!node.children || typeof node.children === 'string') {
        return node.children || ''
      } else if (Array.isArray(node.children)) {
        return getSlotChildrenText(node.children)
      } else if (node.children.default) {
        return getSlotChildrenText(node.children.default())
      }
      return ''
    }
    const getSlotChildrenText = (children) => {
      return children.map(getTextFromNode).join(' ')
    }
    const slotTexts = this.trimKey(
      (this.$slots.default && getSlotChildrenText(this.$slots.default())) || '',
    )
    return slotTexts
    // @TODO fix
    // return this.$slots.default && this.$slots.default[0].text
    //   ? this.trimKey(this.$slots.default[0].text)
    //   : null
  }

  get translation() {
    if (!this.translationKey) {
      this.translationKey = this.getTranslationKey()
    }
    if (this.translationKey) {
      try {
        const result = this.$t(this.translationKey, this.tt)
        return result
      } catch (e) {
        // don't want user to see an error if trans broken
        // but this at least gets it to sentry

        console.error(e)
      }
    }
    return this.translationKey
  }

  trimKey(key: string): string {
    return key.replace(/\s\s+/g, ' ').trim()
  }
}

export default toNative(Translate)
</script>
